import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AndresB_Video4 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoAndres4 = () => {
  return (
    <>
      <ModalVideo
        id="andres-video-4"
        dataText={AndresB_Video4}
        videoSrc="https://player.vimeo.com/video/1208209193?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_AI_ANDRES_VIDEO_4"
      />
    </>
  );
};

export default ModalVideoAndres4;
